export default __webpack_public_path__ + "static/media/zoneSummary.759e0663.png";